import React from "react";
import PropTypes from "prop-types";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const EmployeeCountExport = ({
  columns,
  data,
  tables,
  fileName,
  buttonText = "Export to Excel",
  buttonIcon = null,
  className = "btn btn-primary",
}) => {
  const exportToExcel = () => {
    try {
      const workbook = XLSX.utils.book_new();

      if (tables) {
        tables.forEach((table) => {
          const { sheetName, columns: tableColumns, data: tableData } = table;

          let exportData = [];

          if (Array.isArray(tableData)) {
            exportData = tableData.map((item) => {
              const row = {};
              tableColumns.forEach((col) => {
                row[col.title] = item[col.dataIndex];
              });
              return row;
            });
          } else if (typeof tableData === "object" && tableData !== null) {
            const row = {};
            tableColumns.forEach((col) => {
              row[col.title] = tableData[col.dataIndex];
            });
            exportData.push(row);
          }
          const worksheet = XLSX.utils.json_to_sheet(exportData);
          XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        });
      } else {
        let exportData = [];

        if (Array.isArray(data)) {
          exportData = data.map((item) => {
            const row = {};
            columns.forEach((col) => {
              row[col.title] = item[col.dataIndex];
            });
            return row;
          });
        } else if (typeof data === "object" && data !== null) {
          const row = {};
          columns.forEach((col) => {
            row[col.title] = data[col.dataIndex];
          });
          exportData.push(row);
        }
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
      }
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${fileName}.xlsx`);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      alert("Failed to export data to Excel. Please try again.");
    }
  };

  return (
    <button className={className} onClick={exportToExcel}>
      {buttonIcon}
      {buttonText}
    </button>
  );
};

EmployeeCountExport.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      dataIndex: PropTypes.string.isRequired,
    })
  ),
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  tables: PropTypes.arrayOf(
    PropTypes.shape({
      sheetName: PropTypes.string.isRequired,
      columns: PropTypes.array.isRequired,
      data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    })
  ),
  fileName: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  buttonIcon: PropTypes.node,
  className: PropTypes.string,
};

export default EmployeeCountExport;
